/**
 * Determines if string can be converted to number
 */
export const isNumeric = (str: string): boolean => {
  return str.trim() !== '' && !Number.isNaN(Number(str));
};
